import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontFredoka, theme } from "shared/lib/styles";

import { Heading } from "scmp-app/components/posties/brochure-homepage/heading";

import ImageLine from "./img-line.svg?url";

export const Container = styled.div`
  display: flex;
  justify-content: center;

  margin-inline: 20px;
  padding-block-start: 40px;
  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 560px;
    margin: auto;
  }
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 796px;
    padding-block-start: 64px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 986px;
  }
`;

export const Wrapper = styled.div`
  flex: 1;

  max-inline-size: 796px;
  ${theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 986px;
  }
`;

type ContentWrapperProps = {
  $isEven: boolean;
};

export const LineWrapper = styled.div`
  margin-block: 58px 62px;
  margin-inline: 0;
`;

export const ContentWrapper = styled.div<ContentWrapperProps>`
  display: flex;

  ${props =>
    props.$isEven
      ? css`
          flex-direction: column;
          align-items: center;
          ${theme.breakpoints.up("tablet")} {
            flex-direction: row;
            align-items: flex-start;
          }
        `
      : css`
          flex-direction: column;
          align-items: center;
          ${theme.breakpoints.up("tablet")} {
            flex-direction: row-reverse;
            align-items: flex-start;
          }
        `}
`;

export const ImageWrapper = styled.div``;

export const StyledImg = styled.img`
  block-size: 224px;
  margin-block-start: 24px;
  aspect-ratio: 1/1;
  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
  ${theme.breakpoints.up("desktop")} {
    block-size: 320px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    block-size: 410px;
  }
`;

export const BackgroundImageLine = styled.div`
  position: relative;

  background-image: url(${ImageLine});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  aspect-ratio: 986/12;
`;

type TextWrapperProps = {
  $isEven: boolean;
};

export const TextWrapper = styled.div<TextWrapperProps>`
  display: flex;
  flex-direction: column;

  ${props =>
    props.$isEven
      ? css`
          ${theme.breakpoints.up("tablet")} {
            margin-inline-start: 64px;
          }
        `
      : css`
          ${theme.breakpoints.up("tablet")} {
            margin-inline-end: 64px;
          }
        `}
`;

export const Header = styled(Heading)`
  margin-block-end: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 24px;
  }
`;

export const Description = styled.div`
  margin-block-end: 56px;

  color: #333333;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontFredoka};
  line-height: 22px;
  text-align: center;

  ${theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }
`;

const ContentHeadline = styled.div`
  color: #ff7c1d;
  font-weight: 700;
  font-size: 28px;
  font-family: ${fontFredoka};
  line-height: 34px;

  ${theme.breakpoints.up("desktop")} {
    font-size: 40px;
    line-height: 48px;
  }
`;

export const MobileContentHeadline = styled(ContentHeadline)`
  display: block;
  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const TabletContentHeadline = styled(ContentHeadline)`
  display: none;
  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const SubContentWrapper = styled.div`
  margin-block-start: 32px;
`;

export const SubContentHeadline = styled.div`
  color: #333333;
  font-weight: 600;
  font-size: 24px;
  font-family: ${fontFredoka};
  line-height: 24px;
  letter-spacing: 0.01em;

  ${theme.breakpoints.up("desktop")} {
    font-size: 28px;
    line-height: 32px;
  }
`;

export const SubContentDescription = styled.div`
  margin-block-start: 8px;

  color: #333333;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 22px;

  ${theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }
`;
